import { useMemo } from "react";
import { CustomCellRendererProps } from "ag-grid-react";

import WarningIcon from '@mui/icons-material/Warning';

import { Box, Tooltip } from "@parspec/pixel";

import { WARNING_TOOLTIP } from "src/features/BOM/pricing&LeadTime/shared/constants";
import { MainProductComponentsDataType } from "src/features/BOM/pricing&LeadTime/mainProductTable";

import { DEFAULT_VALUES_WARNING } from "../../constants";
import { checkIfInDiscountFields, DefaultValues } from "../../utils";
import { BOM_TABLES_ENUM } from "src/features/BOM/shared/constants";



const CustomCellRenderer = (params: CustomCellRendererProps, tableData: MainProductComponentsDataType[]) => {
    const field = params.data.field as keyof DefaultValues;
    const shouldShowWarning = useMemo(() => tableData.some((item: any) => {
        const isSelected = params.node.isSelected();
        if (checkIfInDiscountFields(field)) {
            if (field in DEFAULT_VALUES_WARNING && !isSelected && item[field] !== null && item[field] !== item['cost']) {
                return true
            } else {
                if (item.components && item.components.length > 0) {
                    for (const component of item.components) {
                        if (field in DEFAULT_VALUES_WARNING && !isSelected && component[field] !== null && component[field] !== component['cost'])
                            return true;
                    }
                }
            }
        } else {
            if (field in DEFAULT_VALUES_WARNING && !isSelected && item[field] && item[field] !== DEFAULT_VALUES_WARNING[field]) {
                return true
            } else {
                if (item.components && item.components.length > 0 && field !== BOM_TABLES_ENUM.LOT) {
                    for (const component of item.components) {
                        if (field in DEFAULT_VALUES_WARNING && !isSelected && component[field] && component[field] !== DEFAULT_VALUES_WARNING[field])
                            return true;
                    }
                }
            }
        }

        return false;

    }), [tableData, params.node, field])


    return (
        <>{
            shouldShowWarning ? <Box>
                {

                    <Tooltip title={WARNING_TOOLTIP}>
                        <WarningIcon sx={{ color: '#E65100', cursor: "pointer" }} />
                    </Tooltip>

                }
            </Box > : null}</>

    );
};

export default CustomCellRenderer;
